"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FeedbackQuestionsState = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _feedbackQuestions = _interopRequireDefault(require("../reducers/feedbackQuestions"));
var _question = require("../actions/question");
var _UIState = _interopRequireDefault(require("./UIState"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FeedbackQuestionsContext = /*#__PURE__*/(0, _react.createContext)({
  questions: [],
  dispatch: _noop["default"]
});
var FeedbackQuestionsState = exports.FeedbackQuestionsState = function FeedbackQuestionsState(_ref) {
  var applicationId = _ref.applicationId,
    feedbackIntent = _ref.feedbackIntent,
    children = _ref.children;
  var _useReducer = (0, _react.useReducer)(_feedbackQuestions["default"], []),
    _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
    questions = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useContext = (0, _react.useContext)(_UIState["default"]),
    uiDispatch = _useContext.dispatch;
  (0, _react.useEffect)(function () {
    if (applicationId && feedbackIntent) {
      (0, _question.getQuestions)(applicationId, feedbackIntent)(dispatch, uiDispatch);
    }
  }, [applicationId, feedbackIntent]);
  return /*#__PURE__*/_react["default"].createElement(FeedbackQuestionsContext.Provider, {
    value: {
      questions: questions,
      dispatch: dispatch
    }
  }, children);
};
FeedbackQuestionsState.propTypes = {
  applicationId: _propTypes["default"].string.isRequired,
  feedbackIntent: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = FeedbackQuestionsContext;
//# sourceMappingURL=FeedbackQuestionsState.js.map